// One release switch for Miaozi's paid stories. Keep this false until the
// live Dodo products and checkout have been verified, then change to true and
// deploy. Both the web app and checkout Worker import this same value.
export const MONETIZATION_ENABLED = false
